import { render, staticRenderFns } from "./PricingTiers.vue?vue&type=template&id=7318aa8b&scoped=true"
import script from "./PricingTiers.vue?vue&type=script&lang=ts"
export * from "./PricingTiers.vue?vue&type=script&lang=ts"
import style0 from "./PricingTiers.vue?vue&type=style&index=0&id=7318aa8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7318aa8b",
  null
  
)

export default component.exports